import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../views/buttons/Button";
import SeoButton from "../../../views/buttons/Button";
import AddSectionButton from "../../../views/buttons/Button";
import PageTitleButton from "../../../views/buttons/Button";
import wbApi from "../../../API/wbApi";
import { useDispatch, useSelector } from "react-redux";
import { aboutPageAction } from "../../../redux/actions/PageAction";
import { RootState } from "../../../redux/store";
import PageAboutSectionCard from "../../../views/datacard/RectangleSectionCard";
import SaveButton from "../../../views/buttons/Button";
import { Draggable } from "react-drag-reorder";
import AboutPageTitleSlider from "./AboutPageTitleSlider";
import SlidingPane from "react-sliding-pane";
import { toast } from "react-toastify";
import AboutSectionSlider from "./AboutSectionSlider";
import AboutSeoSlider from "./AboutSeoSlider";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import { CATCH_MESSAGE, getImage, Logout } from "../../../UtilityFunctions";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import CardWrapper from "../../../views/datacard/CardWrapper";
import {
  CancelConfirmationPrompt,
  ShowConfirmationPrompt,
} from "../../../redux/actions/PromptAction";
import Loader from "../../../views/loader/Loader";

const AboutPage = () => {
  // Data From Redux
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { page_Id } = useSelector((state: RootState) => state.pages);

  // States
  const [openTitleSlide, setOpenTitleSlide] = useState<boolean>(false);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openSeoSlide, setOpenSeoSlide] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [aboutPageDatas, setAboutPageDatas] = useState<any>({});
  const [allsec, setAllSec] = useState<any[]>([]);
  const [aboutPageSec, setaboutPageSec] = useState<any[]>([]);
  const [updateOrder, setUpdateOrder] = useState<any[]>([]);


  // Variables
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { about_page_details } = aboutPageData ?? {};

  useEffect(() => {
    aboutPageDataFetching();
  }, [company_id, template_id]);

  // Fetching About Page Data

  const aboutPageDataFetching = async () => {
    setLoader(true);

    try {
      let aboutPageRes = await wbApi.get(
        `/wb-dashboard/fetch-about-page-details/${company_id}/${template_id}/${page_Id}`
      );
      if (aboutPageRes.data.status === 1) {
        dispatch(aboutPageAction(aboutPageRes?.data));
        setAboutPageDatas(aboutPageRes?.data?.about_page_details);
        const aboutPageAllSec = aboutPageRes?.data?.all_sections.map(
          (item: any) => {
            return { ...item, isChecked: false };
          }
        );
        setAllSec(aboutPageAllSec);
        setaboutPageSec(aboutPageRes?.data?.about_page_details?.page_section);
        setLoader(false);
      } else {
        setAllSec([]);
        setaboutPageSec([]);
        setLoader(false);
      }
    } catch {
      toast.error(CATCH_MESSAGE);
      setLoader(false);
    }
  };

  // Api To ReOrder
  const orderSaveHandler = async () => {
    setSaveLoader(true);
    try {
      let orderReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: aboutPageDatas?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateOrder,
          page_type: "Default",
          page_id: page_Id ?? "",
        },
        {
          headers: {
            Authorization: "Bearer " + auth_token,
          },
        }
      );
      if (orderReq.data.status === 1) {
        toast.success(orderReq.data.message);
        setDragStatus(false)
        aboutPageDataFetching();
        setSaveLoader(false);
      } else {
        toast.error(orderReq.data.message);
        aboutPageDataFetching();
        setSaveLoader(false);
      }
    } catch (error: any) {
      setSaveLoader(false);
      if (error.response.status === 401) {
        Logout();
        toast.error("Session Expired");
      } else {
        toast.error(CATCH_MESSAGE);
      }

    }
  };

  // Ordering Menus
  const positionHandler = (currentPos: any, newPos: any) => {
    const orderSec = [...aboutPageSec];
    const result = orderSec.splice(currentPos, 1);
    const upDateSec = orderSec.splice(newPos, 0, ...result);
    setDragStatus(true);
    setUpdateOrder(orderSec);
    // console.log(orderSec, "orderSec");
  };

  const [dragStatus, setDragStatus] = useState(false);

  // useEffect used to capture the section order if drag action is not triggered.
  useEffect(() => {
    if (!dragStatus) {
      setUpdateOrder(aboutPageSec)
    }
  }, [aboutPageSec, dragStatus])

  // Draggable Handler

  const DraggableRender = useCallback(() => {
    if (aboutPageSec && aboutPageSec.length > 0) {
      return (
        <Draggable onPosChange={positionHandler}>
          {aboutPageSec.map((sec: any, idx: any) => {
            return (
              <>
                <div className="section-card-wrapper" key={sec.id}>
                  <PageAboutSectionCard
                    onDelet={() => {
                      deleteHandler(idx);
                    }}
                    onEdit={() => {
                      navigate(`/section-default/${sec.section_routes}`);
                    }}
                  >
                    {sec.section_names}
                  </PageAboutSectionCard>
                </div>
              </>
            );
          })}
        </Draggable>
      );
    }
    return null;
  }, [aboutPageSec]);

  // Section Delet Handler
  const deleteHandler = (index: any) => {
    dispatch(
      ShowConfirmationPrompt(
        `Are you sure want to delete this ?`,
        "DELETE",
        async () => {
          await deletSecHandler(index);

          dispatch(CancelConfirmationPrompt());
        }
      )
    );
  };
  const deletSecHandler = (index: any) => {
    let aboutPageSections = aboutPageDatas?.page_section;
    aboutPageSections.splice(index, 1);
    deletAboutSecDetails(aboutPageSections);
  };
  // Delet Section Post
  const deletAboutSecDetails = async (updateSec: any) => {
    try {
      let deletAboutSecReq = await wbApi.post(
        "/wb/insert-update-page-section",
        {
          id: aboutPageDatas?.id ?? "undefined",
          template_id: template_id,
          company_id: company_id,
          page_section: updateSec ?? [],
          page_type: "Default",
          page_id: page_Id ?? "",
        }
      );
      // console.log("deletHomeSecReq", deletAboutSecReq);
      if (deletAboutSecReq.data.status === 1) {
        toast.success(deletAboutSecReq.data.message);
        aboutPageDataFetching();
      } else {
        toast.error(deletAboutSecReq.data.message);
        aboutPageDataFetching();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  return (
    <>

      {/* Sub-Header */}
      <div className="wb-subheader">
        {/* BreadCrumbs */}
        <CustomBreadcrumbs
          content={[
            {
              label: "Pages",
              href: "/pages-default",
            },
            {
              label: `Default Pages`,
              href: "/pages-default",
            },
            {
              label: "About Us",
            },
          ]}
        />

        <div className="wb-subheader-rightsec">
          <SeoButton
            icon="bi bi-binoculars"
            handleClick={() => {
              setOpenSeoSlide(true);
            }}
          >
            SEO
          </SeoButton>
          <PageTitleButton
            icon="bi bi-info-circle"
            handleClick={() => {
              setOpenTitleSlide(true);
            }}
          >
            Page Title
          </PageTitleButton>
          <BackButton
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </BackButton>
        </div>
      </div>
      <div className="wb-divider"></div>

      {/* Main Section */}

      {loader ? (
        <div className="middle-loader">
          <Loader />
        </div>
      ) : (
        <>
          <div className=" mt-4 banner-img-wrapper">
            {aboutPageDatas !== null ? (
              aboutPageDatas?.banner ? (
                <img
                  src={`${getImage(aboutPageDatas?.banner)}`}
                  alt={aboutPageDatas?.banner_alt}
                  className="banner-img"
                />
              ) : aboutPageDatas?.video_banner ? (
                <video width="100%" height="300" controls autoPlay>
                  <source
                    src={`${getImage(aboutPageDatas?.video_banner)}`}
                  />
                </video>
              ) : aboutPageDatas?.video_banner_link ? (
                <iframe
                  src={aboutPageDatas?.video_banner_link}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  height="100%"
                  width="100%"
                ></iframe>
              ) : (
                <NoDataComponent message="No Banner Found" />
              )
            ) : (
              <NoDataComponent message="No Data Found" />
            )}

            <div
              className="edit-btn-banner"
              onClick={() => {
                navigate("edit-about");
              }}
            >
              <i className="bi bi-pencil-square"></i>
            </div>
            {/* <div className="banner-titel">
              <div className="b-titel-text">
                {aboutPageDatas?.banner_title ? (
                  <div className="">{aboutPageDatas?.banner_title}</div>
                ) : (
                  <div className="no-banner-titel">
                    TITLE ON THE BANNER
                  </div>
                )}
              </div>
            </div> */}
          </div>

          <CardWrapper className="mt-4 about-add-sec-card">
            <AddSectionButton
              icon="bi bi-plus-lg"
              className="section-btn"
              handleClick={() => {
                setOpen(true);
              }}
            >
              Select Section
            </AddSectionButton>
          </CardWrapper>

          {/* For Section */}

          <CardWrapper className=" mt-4 mb-4 home-section-save-wrapper">
            {aboutPageSec?.length > 0 ? (
              <>
                <DraggableRender />
                <SaveButton
                  className="save-btn"
                  handleClick={() => {
                    orderSaveHandler();
                  }}
                  loader={saveLoader}
                >
                  Save
                </SaveButton>
              </>
            ) : (
              <NoDataComponent message="No Section Found" />
            )}


          </CardWrapper>
        </>
      )}

      {/* For Seo */}

      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openSeoSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenSeoSlide(false)}
      >
        <AboutSeoSlider
          onClose={() => {
            setOpenSeoSlide(false);
          }}
          aboutPageDataFetching={aboutPageDataFetching}
          aboutPageDatas={aboutPageDatas}
        />
      </SlidingPane>

      {/* For Title */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={openTitleSlide}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpenTitleSlide(false)}
      >
        <AboutPageTitleSlider
          onClose={() => {
            setOpenTitleSlide(false);
          }}
          aboutPageDataFetching={aboutPageDataFetching}
          aboutPageDatas={aboutPageDatas}
        />
      </SlidingPane>

      {/* For Section */}
      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={open}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpen(false)}
      >
        <AboutSectionSlider
          onClose={() => {
            setOpen(false);
          }}
          aboutPageDataFetching={aboutPageDataFetching}
          allsec={allsec}
          aboutPageDatas={aboutPageDatas}
        />
      </SlidingPane>
    </>
  );
};

export default AboutPage;
